import React from 'react';
import { NavLink } from 'react-router-dom';
import { Row } from 'reactstrap';
// import { Colxx } from '../../../components/common/CustomBootstrap';
import { scroller } from "react-scroll";



const scrollTo = (event, target) => {
  event.preventDefault();
  scroller.scrollTo(target, {
    duration: 500,
    delay: 0,
    smooth: "easeInOutQuart",
    offset: -100,
  });
  return false;
};

const Footer = () => {
  return (
    // <footer className="page-footer footer-bg-color">
    //   <div className="footer-content">
    //     <div className="container-fluid">
    //       <Row>
    //         <Colxx xxs="12" sm="6">
    //           <p className="mb-0 text-muted">Teamanics 2022</p>
    //         </Colxx>
    //         <Colxx className="col-sm-6 d-none d-sm-block">
    //           <ul className="breadcrumb pt-0 pr-0 float-right">
    //             <li className="breadcrumb-item mb-0">
    //               <NavLink className="btn-link" to="#" location={{}}>
    //                 Review
    //               </NavLink>
    //             </li>
    //             <li className="breadcrumb-item mb-0">
    //               <NavLink className="btn-link" to="#" location={{}}>
    //                 requests
    //               </NavLink>
    //             </li>
    //             <li className="breadcrumb-item mb-0">
    //               <NavLink className="btn-link" to="#" location={{}}>
    //                 Docs
    //               </NavLink>
    //             </li>
    //           </ul>
    //         </Colxx>
    //       </Row>
    //     </div>
    //   </div>
    // </footer>



    <div className="footer-background fixed-end">
        <div className="">
          <div className="row footer-row">
            {/* <div className="col-12 text-right">
              <a
                className="btn"
                href="#scroll"
                onClick={(event) => scrollTo(event, "home")}
              >
                <i className="simple-icon-arrow-up" />
              </a>
            </div> */}
            <br />
          </div>
        </div>
        <div className=" copyright pt-1 pb-1">
          <div className="row">
            <div className="col-12" />
            <div className="col-12 text-center">
              <p className="mb-0">
                50 California Street, Suite 1500, San Francisco, CA 94111
              </p>
              <p className="mb-0">info@teamanics.com</p>
            </div>
          </div>
        </div>
        <div className=" copyright pt-5 pb-5">
          <div className="row">
            <div className="col-12" />
            <div className="col-12 text-center">
              <p className="mb-0">© 2020 - 2022 Teamanics™</p>
              <p className="mb-0">
                Teamanics is a trademark and service of Metabyte, Inc.
              </p>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Footer;
